export const MoreText = 'More';
export const ErrorText = 'Error fetching templates';
export const EditText = 'Edit';
export const templatesLimit = 20;
